import { Card, CardContent, CardHeader } from "@/components/atoms/Card";
import { ComponentRepeater } from "@/components/atoms/ComponentRepeater";
import { DrawerTitle } from "@/components/atoms/Drawer";
import UcConnection from "@/components/atoms/Icon/ucConnection";
import { NextImage } from "@/components/atoms/NextImage";
import { Skeleton } from "@/components/atoms/Skeleton";
import { useAuthUser } from "@/hooks/common/useAuthUser";

const InstallAppDrawerSkeleton = () => {
  const { workspaceConfig } = useAuthUser();

  return (
    <div className="p-4">
      <div className="flex justify-between items-center">
        <Skeleton className="w-56 h-6 rounded-xl border" />
        <DrawerTitle />

        <div className="flex gap-2">
          <Skeleton className="w-28 h-8 rounded-xl border" />
          <Skeleton className="w-28 h-8 rounded-xl border" />
        </div>
      </div>
      <div className="w-full max-w-[1280px] mx-auto mt-12 px-4">
        <Card className="w-full p-6 max-sm:px-0">
          <CardContent>
            <div className="flex flex-row gap-5 items-center justify-center text-center">
              <div className="flex flex-col gap-2 items-center">
                <Skeleton className="w-[88px] h-[88px] rounded-xl border" />
                <Skeleton className="w-16 h-4 rounded-xl border" />
              </div>

              <div className="relative w-1/4 h-0.5 flex justify-center border-b border-dashed border-primary-selected dark:border-primary">
                <div className="w-14 h-14 px-2 bg-background absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-center rounded-full">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent">
                    <div className="animate-bounce ">
                      {workspaceConfig?.isCore ? (
                        <UcConnection />
                      ) : (
                        <NextImage
                          src={
                            workspaceConfig?.faviconUrl ||
                            "/assets/images/png/usite.png"
                          }
                          width={20}
                          height={20}
                          alt="logo"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-col gap-2 items-center">
                <Skeleton className="w-[88px] h-[88px] rounded-xl border" />
                <Skeleton className="w-16 h-4 rounded-xl border" />
              </div>
            </div>
          </CardContent>
        </Card>
        <Card className="w-full p-6 pt-0 mt-6 max-sm:px-0">
          <CardHeader>
            <Skeleton className="w-52 h-6 rounded-xl border" />
          </CardHeader>
          <CardContent>
            <div className="flex flex-row flex-wrap items-center justify-between">
              <ComponentRepeater
                component={
                  <ul className="ml-6 list-disc [&>li]:mt-2">
                    <li>
                      <Skeleton className="w-52 h-6 rounded-xl border" />
                    </li>
                    <li>
                      <Skeleton className="w-52 h-6 rounded-xl border" />
                    </li>
                    <li>
                      <Skeleton className="w-52 h-6 rounded-xl border" />
                    </li>
                    <li>
                      <Skeleton className="w-52 h-6 rounded-xl border" />
                    </li>
                  </ul>
                }
                count={3}
              />
            </div>
          </CardContent>
        </Card>
        <div className="mt-3 flex gap-4">
          <Skeleton className="w-52 h-6 rounded-xl border" />
          <Skeleton className="w-52 h-6 rounded-xl border" />
        </div>
      </div>
    </div>
  );
};

export default InstallAppDrawerSkeleton;
